export default __webpack_public_path__ + "static/media/640_business06-fr-mobile.7eae96c6.png";